<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24">
          <a-col :lg="6" :md="6" :sm="24" :xl="6">
            <a-form-item label="供水流域">
              <j-dict-select-tag
                @change="searchQuery"
                dictCode="`iwt-wf`.dev_process,process_name,id"
                placeholder="请选择供水流域"
                v-model="queryParam.processId"
              />
            </a-form-item>
          </a-col>

          <a-col :lg="6" :md="6" :sm="24" :xl="6">
            <a-form-item label="类型">
              <j-search-select-tag
                @change="searchQuery"
                dict="`iwt-wf`.iot_sensor_model,model_name,id, 1=1 order by model_name asc"
                placeholder="请选择类型"
                v-model="queryParam.sensorModelId"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="6" :md="6" :sm="24" :xl="6">
            <a-form-item label="运行状态">
              <j-multi-select-tag
                @change="searchQuery"
                dictCode="sensor_running_status"
                placeholder="运行状态"
                type="checkbox"
                v-model="queryParam.runningStatus"
              />
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :lg="6" :md="6" :sm="24" :xl="6">
              <a-form-item label="传感器名称">
                <a-input @change="searchQuery" placeholder="请输入传感器名称" v-model="queryParam.sensorName"></a-input>
              </a-form-item>
            </a-col>
            <a-col :lg="11" :md="12" :sm="24" :xl="10">
              <a-form-item label="安装时间">
                <j-date
                  :show-time="true"
                  @change="searchQuery"
                  class="query-group-cust"
                  date-format="YYYY-MM-DD HH:mm:ss"
                  placeholder="请选择开始时间"
                  v-model="queryParam.installTime_begin"
                ></j-date>
                <span class="query-group-split-cust"></span>
                <j-date
                  :show-time="true"
                  @change="searchQuery"
                  class="query-group-cust"
                  date-format="YYYY-MM-DD HH:mm:ss"
                  placeholder="请选择结束时间"
                  v-model="queryParam.installTime_end"
                ></j-date>
              </a-form-item>
            </a-col>
            <a-col :lg="7" :md="8" :sm="24" :xl="6">
              <a-form-item label="安装位置">
                <a-input @change="searchQuery" placeholder="请输入安装位置" v-model="queryParam.location"></a-input>
              </a-form-item>
            </a-col>
            <a-col :lg="11" :md="12" :sm="24" :xl="10">
              <a-form-item label="上次上线时间">
                <j-date
                  :show-time="true"
                  @change="searchQuery"
                  class="query-group-cust"
                  date-format="YYYY-MM-DD HH:mm:ss"
                  placeholder="请选择开始时间"
                  v-model="queryParam.lastTime_begin"
                ></j-date>
                <span class="query-group-split-cust"></span>
                <j-date
                  :show-time="true"
                  @change="searchQuery"
                  class="query-group-cust"
                  date-format="YYYY-MM-DD HH:mm:ss"
                  placeholder="请选择结束时间"
                  v-model="queryParam.lastTime_end"
                ></j-date>
              </a-form-item>
            </a-col>
            <a-col :lg="7" :md="8" :sm="24" :xl="6">
              <a-form-item label="关联设备">
                <j-dict-select-tag
                  @change="searchQuery"
                  dictCode="`iwt-wf`.dev_list,dev_name,id,del_flag=0 order by sort asc"
                  placeholder="请选择关联设备"
                  v-model="queryParam.devId"
                />
              </a-form-item>
            </a-col>
          </template>
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" icon="plus" type="primary">新增</a-button>
      <a-button @click="handleExportXls('传感器台账')" icon="download" type="primary">导出</a-button>
      <a-upload
        :action="importExcelUrl"
        :headers="tokenHeader"
        :multiple="false"
        :showUploadList="false"
        @change="handleImportExcel"
        name="file"
      >
        <a-button icon="import" type="primary">导入</a-button>
      </a-upload>
      <a-button @click="relatePoints" icon="swap" style="margin-left: 8px">测点关联</a-button>
      <!-- 高级查询区域 -->
      <j-super-query :fieldList="superFieldList" @handleSuperQuery="handleSuperQuery" ref="superQueryModal"></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="batchDel" key="1">
            <a-icon type="delete" />删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>

      <a-table
        :columns="columns"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :scroll="{ x: true }"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <img
            :src="getImgView(text)"
            alt
            height="25px"
            style="max-width:80px;font-size: 12px;font-style: italic;"
            v-else
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
          <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else>下载</a-button>
        </template>
        <span slot="isAcknowledgementSlot" slot-scope="isAcknowledgement, record">
          <a-tag color="gray" v-if="record.isAcknowledgement == 0">未确认</a-tag>
          <a-tag color="#52c41a" v-else>已确认</a-tag>
        </span>
        <span slot="runStatusSlot" slot-scope="runningStatus, record">
          <a-tag color="#ff4d4f" v-if="record.runningStatus == 'Alert'">告警</a-tag>
          <a-tag color="#52c41a" v-else-if="record.runningStatus == 'Online'">在线</a-tag>
          <a-tag color="gray" v-else>离线</a-tag>
        </span>
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm @confirm="() => handleDelete(record.id)" title="确定删除吗?">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>

    <iot-sensor-list-modal @ok="modalFormOk" ref="modalForm"></iot-sensor-list-modal>
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import IotSensorListModal from './modules/IotSensorListModal'
  import { filterMultiDictText } from '@/components/dict/JDictSelectUtil'
  import { httpAction } from '@/api/manage'

  export default {
    name: 'IotSensorListList',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      IotSensorListModal
    },
    data () {
      return {
        description: '传感器台账管理页面',
        // 表头
        columns: [
          {
            title: '区域',
            align: 'center',
            sorter: true,
            dataIndex: 'processId_dictText'
          },
          {
            title: '设备',
            align: 'center',
            sorter: true,
            dataIndex: 'devId_dictText'
          },
          {
            title: '安装点',
            align: 'center',
            sorter: true,
            dataIndex: 'installPoint'
          },
          {
            title: '传感器名称',
            align: 'center',
            sorter: true,
            dataIndex: 'sensorName'
          },
          // {
          //   title: '类型',
          //   align: 'center',
          //   sorter: true,
          //   dataIndex: 'sensorModelId_dictText'
          // },

          {
            title: '安装点编号',
            align: 'center',
            sorter: true,
            dataIndex: 'installPointCode'
          },
          {
            title: '逻辑地址',
            align: 'center',
            sorter: true,
            dataIndex: 'logicAddr'
          },

          {
            title: '安装时间',
            align: 'center',
            sorter: true,
            dataIndex: 'installTime'
          },
          {
            title: '照片',
            align: 'center',
            dataIndex: 'pictureObjId',
            scopedSlots: { customRender: 'imgSlot' }
          },
          {
            title: '运行状态',
            align: 'center',
            sorter: true,
            dataIndex: 'runningStatus_dictText',
            scopedSlots: { customRender: 'runStatusSlot' }
          },
          {
            title: '上次上线时间',
            align: 'center',
            sorter: true,
            dataIndex: 'lastTime'
          },

          {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            fixed: 'right',
            width: 147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        isorter: {
          column: 'installPoint',
          order: 'asc'
        },
        url: {
          list: '/monitor/sensor/list',
          delete: '/monitor/sensor/delete',
          deleteBatch: '/monitor/sensor/deleteBatch',
          exportXlsUrl: '/monitor/sensor/exportXls',
          importExcelUrl: 'monitor/sensor/importExcel',
          relatePoints: '/monitor/sensor/relatePoints'
        },
        dictOptions: {},
        superFieldList: []
      }
    },
    created () {
      this.getSuperFieldList()
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
      }
    },
    methods: {
      relatePoints () {
        httpAction(this.url.relatePoints, {}, 'post').then(res => {
          if (res.success) {
            $message.success(res.message)
          } else {
            this.$message.warning('关联失败，请稍后尝试')
          }
        })
      },
      initDictConfig () { },
      getSuperFieldList () {
        let fieldList = []
        fieldList.push({ type: 'string', value: 'sensorName', text: '传感器名称', dictCode: '' })
        fieldList.push({
          type: 'string',
          value: 'sensorModelId',
          text: '类型ID',
          dictCode: '`iwt-wf`.iot_sensor_model,model_name,id'
        })
        fieldList.push({ type: 'string', value: 'location', text: '安装位置', dictCode: '' })
        fieldList.push({ type: 'string', value: 'coordinateWgs84', text: '谷歌经纬度坐标', dictCode: '' })
        fieldList.push({ type: 'string', value: 'coordinateGcj02', text: '高德(安卓)经纬度坐标', dictCode: '' })
        fieldList.push({ type: 'datetime', value: 'installTime', text: '安装时间' })
        fieldList.push({ type: 'string', value: 'pictureObjId', text: '照片', dictCode: '' })
        fieldList.push({ type: 'string', value: 'qrcode', text: '二维码', dictCode: '' })
        fieldList.push({ type: 'string', value: 'runningStatus', text: '运行状态', dictCode: '' })
        fieldList.push({ type: 'datetime', value: 'lastTime', text: '上次上线时间' })
        fieldList.push({ type: 'string', value: 'devId', text: '关联设备', dictCode: '`iwt-wf`.dev_list,dev_name,id' })
        fieldList.push({ type: 'string', value: 'firmwareVersion', text: '固件版本', dictCode: '' })
        fieldList.push({ type: 'string', value: 'description', text: '备注', dictCode: '' })
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>
